export const getTabId = (value) => `tab${value}`;
export const getPanelId = (value) => `panel${value}`;
